export default function placeDecimal(value, places) {
  const str = String(Math.abs(Number(value))).padStart(places + 1, '0');
  if (places === 0) return str;
  return (
    str.slice(0, str.length - places) + '.' + str.slice(str.length - places)
  );
}
